var _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlabCalculator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 30 L80 20 L95 30 L25 40 Z",
    fill: "#F3F4F6",
    stroke: "#374151",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30 L25 40 L25 44 L10 34 Z",
    fill: "#D1D5DB",
    stroke: "#374151",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34 L25 44 L25 64 L10 54 Z",
    fill: "#9CA3AF",
    stroke: "#374151",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40 L95 30 L95 34 L25 44 Z",
    fill: "#E5E7EB",
    stroke: "#374151",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44 L95 34 L95 54 L25 64 Z",
    fill: "#BDC3C7",
    stroke: "#374151",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 44) skewY(-8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 10,
    rx: 6,
    ry: 7,
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35,
    cy: 10,
    rx: 6,
    ry: 7,
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 10,
    rx: 6,
    ry: 7,
    fill: "#2C3E50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlabCalculator);
export default __webpack_public_path__ + "static/media/slab_calculator.ca48f6e9ba708ffddc66588009a16781.svg";
export { ForwardRef as ReactComponent };